import CnpjValidate from './cnpj'
const CnpjValidator = {
  getMessage (field, args) { // will be added to default English messages.
    return 'CNPJ Inválido'
  },
  validate (value, args) {
    return CnpjValidate(value)
  }
}
export default CnpjValidator



// WEBPACK FOOTER //
// ./src/validators/cnpj.validator.js